<template>
  <footer class="footer has-cards">
    <div class="container">
      <hr />
      <div class="row align-items-center justify-content-md-between">
        <div class="col-md-4">
          <div class="copyright">
            &copy; {{ year }}
            <a href="#" target="_blank" rel="noopener">Creado por </a>
            <a href="#" target="_blank" rel="noopener">ASIGEO MEDIOS</a>
          </div>
        </div>

        <div class="col-md-4 text-center">
          <a
            href="https://aula.ibldvenezuela.com/"
            target="_blank"
            title="Creative Tim - Premium Bootstrap Themes and Templates"
          >
            <span class="text-black alpha-7">Nuestra aula virtual</span>
            <img
              src="https://aula.ibldvenezuela.com/pluginfile.php/1/theme_klass/logo/1596670256/Logo_mejorado.png"
              class="ml-3"
              style="height: 30px;"
            />
          </a>
        </div>

        <div class="col-md-4 text-center">
          <ul class="nav nav-footer justify-content-end">
            <li class="nav-item">                
              <a
                href="https://www.instagram.com/ibldvenezuela/"
                class="nav-link"
                target="_blank"
                rel="noopener"
                >
                <b-icon icon="instagram"></b-icon>
                Instagram</a
              >
            </li>
            <li class="nav-item">
              <a
                href="https://www.facebook.com/IBLDVenezuela"
                class="nav-link"
                target="_blank"
                rel="noopener"
                >
                <b-icon icon="facebook"></b-icon>
                Facebook</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "app-footer",
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style></style>
